const Ellipse1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="909"
      height="576"
      viewBox="0 0 909 576"
      fill="none"
    >
      <g filter="url(#filter0_f_21_13)">
        <circle
          cx="520"
          cy="357"
          r="320"
          fill="url(#paint0_linear_21_13)"
          fill-opacity="0.7"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_21_13"
          x="0"
          y="-163"
          width="1040"
          height="1040"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_21_13"
          />
        </filter>
        <linearGradient
          id="paint0_linear_21_13"
          x1="520"
          y1="37"
          x2="520"
          y2="677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2D061B" />
          <stop offset="1" stop-color="#B9317A" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Ellipse1